import isItemView from 'owa-mail-store/lib/utils/isItemView';

export function getReadingPaneDeepLinkURL(rowId: string): string {
    const DEEPLINK_READ_ROUTE = isItemView() ? 'read' : 'readconv';
    return `${window.origin}/mail/deeplink/${DEEPLINK_READ_ROUTE}/${encodeURIComponent(rowId)}`;
}
